import { render } from "./CustomFieldLabelSelector.vue?vue&type=template&id=6a49b8f1&scoped=true"
import script from "./CustomFieldLabelSelector.vue?vue&type=script&lang=js"
export * from "./CustomFieldLabelSelector.vue?vue&type=script&lang=js"

import "./CustomFieldLabelSelector.vue?vue&type=style&index=0&id=6a49b8f1&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6a49b8f1"]])

export default __exports__